// Centralised brand label. Override at build time via
//   REACT_APP_BRAND_NAME=...   (in landing-page/.env)
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || 'MyDr.Ai';

// Core positioning line from the Website Build Handoff V1.0 (sec. 1).
export const BRAND_POSITIONING =
  'Doctor-led. AI-assisted. Science-backed. Personalised for Malaysians.';

// Brand promise — Phase 1 only.
export const BRAND_PROMISE = "Malaysia's AI-Powered Medical Weight Loss Platform";
